import React, { useState, useRef } from 'react';
import { handlePointerDown} from '../../lib/modal-helper';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector } from 'react-redux';
import ErrorMessage from '../../app/ErrorMessage';
import { useDispatch } from 'react-redux';
import { verifyPassword } from '../user/userSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { getUdid } from '../../api/mobile';


const VerifyPasswordModal = ({onGoBack, onGoAhead}) => {
    const strings = useSelector(selectAllStrings);
    const [password, setPassword] = useState('');
    const [verifyRequestStatus, setVerifyRequestStatus] = useState('idle');
    const [error, setError] = useState('');

    const dispatch = useDispatch();
    const onPasswordChanged = (event) => setPassword(event.target.value);
    const passwordRef = useRef(null);
    const toggleShowPassword = (event) => {
        
        event.preventDefault();
        event.stopPropagation();
        passwordRef.current.type = passwordRef.current.type == 'password' ? 'text' : 'password';
        event.target.className = event.target.className ==
                'toggle-show-password' ? 'toggle-show-password hide' :
                'toggle-show-password';
    };
    const canContinue = password && verifyRequestStatus === 'idle';
    const onContinueClicked = async (event) => {
        event.preventDefault();
        if (canContinue) {
            try {
                setVerifyRequestStatus('pending');
                const udid = await getUdid();
                const resultAction = await dispatch(
                        verifyPassword({code: password, udid: udid})
                        );
                
                unwrapResult(resultAction);
                
                if (resultAction.payload.status == 1) {
                    onGoAhead();
                } else {
                    setError(resultAction.payload.msg);
                    setPassword('');
                }
            } catch (err) {
                setError(err.message);
                setVerifyRequestStatus('failed');
            } finally {
                setVerifyRequestStatus('idle');
            }
        }
    };

    return (error ? <ErrorMessage strings={strings} message={error} onGoBack={() => setError('')} /> :
            <div className="modal" id="insert_password_modal">
                <div className="modal-body" id="insert_password_modal_body">
                    <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'insert_password_modal_body')}>
                        <div className="move-handler"></div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'insert_password_modal_body')}>
            
                            <a className="close-modal" onPointerDown={event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    onGoBack();
                                   }}></a>
                            <span onPointerDown={event => event.preventDefault()}>{strings.free_trial}</span>
                            <hr/>
                        </div>
                        <div className="modal-title">{strings.we_sent_mail}</div>
                        <div className="modal-text">{strings.dont_get_mail}</div>
                        <form>
                            <label className="password-label">{strings.insert_password}
                                <input ref={passwordRef} type="password" id="password" placeholder={strings.password} required value={password} onChange={onPasswordChanged}/>
                                <span className="toggle-show-password" onClick={toggleShowPassword}></span>
                            </label>
                            <button className="btn" id="continue_button" onClick={onContinueClicked} disabled={!canContinue}>
                            {verifyRequestStatus === 'pending' ? <div className="loader"></div> : strings.continue}
                            </button>
                        </form>
                    </div>
                </div>
            </div>);
};


export default VerifyPasswordModal;

